import React,{ Fragment } from "react";
import { MdClose } from "react-icons/md";


export const addNotification = (props, message, variant = "info") => {
  const action = (key) => (
    <Fragment>
      <button
        className='btn btn-light btn-sm rounded-circle'
        onClick={() => {
          props.closeSnackbar(key);
        }}
      >
        <MdClose />
      </button>
    </Fragment>
  );
  const options = {
    variant,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
      autoHideDuration: 900,
    },
    action,
  };
  return props.enqueueSnackbar(message, options);
};




export const returnDate = (type, date = null) => {
  if (type === "CDATE") {
    return new Date();
  } else if (type === "SDATE") {
    return new Date(date);
  }
};

export function formatDate(date, plusDate = null) {
  date = date ? date : new Date();
  if (plusDate) {
    date = new Date(date);
    date.setDate(date.getDate() + plusDate);
  }

  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join("-");
}

export function formatDateTime(date, format = "/") {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  const cdate = [year, month, day].join(format);
  let hours = d.getHours();
  let minutes = d.getMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  let strTime = hours + ":" + minutes + " " + ampm;
  return [cdate, strTime].join(" ");
}

export const DaysDiff = (d1, d2) => {
  let date1 = new Date(d1);
  let date2 = new Date(d2);

  let Difference_In_Time = date2.getTime() - date1.getTime();

  let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

  return Difference_In_Days;
};

export const StringDate = (date = null) => {
  if (!date) {
    new Date().toLocaleString("default", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }
  return new Date(date).toLocaleString("default", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const StringTime = (date = null) => {
  if (!date) {
    new Date().toLocaleString("default", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  return new Date(date).toLocaleString("default", {
    hour: "2-digit",
    minute: "2-digit",
  });
};
